import React from "react"
import { Helmet } from 'react-helmet';
import '../utils/fontawesome'

import Header from "./header"
import Footer from "./footer"

export default ({ children }) => (
    <div className="layout">
        <Helmet>
            <title>Boundes End Garden</title>
        </Helmet>
        <Header />
        <div className="content">
            <main>
                {children}
            </main>
        </div>
        <Footer />
    </div>
)